<template>
    <div class="relative inline-flex" v-click-outside="close">
        <a
            href="#"
            @click.prevent="actionsOpen = !actionsOpen"
            aria-haspopup="true"
            :aria-expanded="actionsOpen"
            role="button"
            class="rounded-full w-8 lg:w-10 h-8 lg:h-10 flex items-center justify-center hover:bg-gray-100 outline-none"
        >
            <span>
                <i
                    class="far fa-ellipsis-h text-base lg:text-xl text-gray-400"
                ></i>
            </span>
        </a>
        <div
            class="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-gray-200 pt-1.5 rounded shadow-sm overflow-hidden mt-1"
            v-show="actionsOpen"
        >
            <ul class="mb-2">
                <li class="py-1 px-3">
                    <a
                        class="font-medium text-sm text-gray-800 hover:text-gray-600 flex items-center"
                        href="#"
                        @click.prevent="editCard"
                    >
                        Edit
                    </a>
                </li>
                <li class="py-1 px-3">
                    <a
                        class="font-medium text-sm text-gray-800 hover:text-gray-600 flex items-center"
                        href="#"
                        @click.prevent="copyCard"
                    >
                        Copy card details
                    </a>
                </li>
                <li class="py-1 px-3" v-if="!item.guid && !item.member_guid">
                    <span
                        v-if="!deleteAction"
                        class="font-medium text-sm text-red-500 hover:text-red-700 flex items-center cursor-pointer"
                        role="button"
                        @click.prevent="deleteAction = true"
                    >
                        Remove
                    </span>

                    <div v-if="deleteAction">
                        <div
                            class="inline-flex px-2 py-2 rounded-sm text-sm bg-red-200 border border-red-200 text-red-500"
                        >
                            <div
                                class="flex w-full justify-between items-center"
                            >
                                <div class="flex items-center">
                                    <svg
                                        viewBox="0 0 512 512"
                                        class="w-5 h-5 shrink-0 fill-current opacity-80 mt-3px"
                                    >
                                        <path
                                            d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
                                        />
                                    </svg>
                                    <div class="text-sm text-left ml-3">
                                        Are you sure?
                                        <a
                                            href="#"
                                            class="text-orange font-bold hover:text-orange-light"
                                            role="button"
                                            @click.prevent="confirmedDelete"
                                        >
                                            Yes
                                        </a>
                                        or
                                        <a
                                            href="#"
                                            role="button"
                                            class="font-bold hover:text-orange-light"
                                            @click.prevent="
                                                deleteAction = false
                                            "
                                        >
                                            No
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
    props: {
        item: Object,
    },
    data: () => ({
        actionsOpen: false,
        deleteAction: false,
    }),
    watch: {
        actionsOpen(val) {
            if (!val) {
                this.deleteAction = false;
            }
        },
    },
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    methods: {
        editCard() {
            this.$emit('edit-card');
        },
        copyCard() {
            this.$emit('copy-card');
        },
        confirmedDelete() {
            this.$emit('delete-card');
        },
        close() {
            this.deleteAction = false;
            this.actionsOpen = false;
        },
    },
    mounted() {},
};
</script>
